import { io } from "socket.io-client";

// Socket server ตัวเดียวกับแจ้งเตือนใบเสนอราคา (ย้ายมาจาก App.js ให้มี connection เดียวทั้งแอป)
const SOCKET_URL =
  process.env.NODE_ENV === "production"
    ? "https://socket-server-h4f6.onrender.com"
    : "http://localhost:8080";

let socket = null;
let registeredRoom = "";
const listeners = new Set();

export const getNotificationRoom = (user) =>
  String(user?.username || user?.email || "").toLowerCase().trim();

const connect = (room) => {
  if (socket && registeredRoom === room) return;
  disconnectNotificationSocket();

  registeredRoom = room;
  socket = io(SOCKET_URL, {
    transports: ["websocket"],
    reconnectionAttempts: 5,
  });

  // ลงทะเบียน room ใหม่ทุกครั้งที่ connect (รวมถึงตอน reconnect) ไม่งั้น server จะลืม room
  socket.on("connect", () => {
    socket.emit("register", room);
  });

  socket.on("disconnect", (reason) => {
    console.warn(`🔴 Socket disconnected (${reason})`);
  });

  socket.on("notification", (payload) => {
    listeners.forEach((listener) => {
      try {
        listener(payload || {});
      } catch (error) {
        console.error("Notification listener failed:", error);
      }
    });
  });
};

// คืนฟังก์ชัน unsubscribe; socket ยังเปิดค้างไว้จน logout เพื่อไม่ให้ต่อใหม่ทุกครั้งที่เปลี่ยนหน้า
export const subscribeNotificationSocket = (room, listener) => {
  if (!room) return () => {};
  connect(room);
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const disconnectNotificationSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }
  socket = null;
  registeredRoom = "";
};
